import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import ArtistUpiForm from "../components/ArtistUpiForm";

const ArtistUpiSetup = () => {
    const navigate = useNavigate();
    const [authUser, setAuthUser] = useState(null);
    const [checking, setChecking] = useState(true);
    const [userRole, setUserRole] = useState(null);

    useEffect(() => {
        if (auth.currentUser) {
            setAuthUser(auth.currentUser);
            setChecking(false);
            return;
        }
        const unsub = onAuthStateChanged(auth, (user) => {
            if (!user) {
                navigate("/login", { replace: true });
                return;
            }
            setAuthUser(user);
            setChecking(false);
        });
        return () => unsub();
    }, [navigate]);

    useEffect(() => {
        if (!authUser?.uid) return;
        let active = true;
        (async () => {
            try {
                const userRef = doc(db, "users", authUser.uid);
                const snap = await getDoc(userRef);
                if (!snap.exists()) {
                    if (active) navigate("/setup-name", { replace: true });
                    return;
                }
                const data = snap.data();
                if (active) {
                    const role = data?.role || null;
                    setUserRole(role);
                    if (role !== "artist") {
                        navigate("/", { replace: true });
                    }
                }
            } catch (err) {
                console.error("Failed to verify role:", err);
            }
        })();
        return () => {
            active = false;
        };
    }, [authUser?.uid, navigate]);

    if (checking) {
        return (
            <div className="min-h-screen bg-[#0e0e0e] text-white flex items-center justify-center">
                <div>Loading...</div>
            </div>
        );
    }

    return (
        <ArtistUpiForm
            user={authUser}
            heading="Enter Your Artist UPI ID"
            subheading="So supporters can tip you instantly via UPI."
            onComplete={() => navigate("/", { replace: true })}
            onBack={() => navigate("/select-role", { replace: true })}
        />
    );
};

export default ArtistUpiSetup;

